<template>
  <div>
    <modal-user :data="this.data_row" />
    <div
      class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">Overview</h6>
            <h2 class="text-black text-xl font-semibold">Users - Data Table</h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <!-- Chart -->
        <div class="relative">
          <vue-good-table
            :columns="columns"
            :lineNumbers="true"
            :rows="users"
            @on-row-click="onRowClick"
            :search-options="{
              enabled: true,
              placeholder: 'Search User'
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span class="items-center justify-center" v-if="props.column.field == 'avatar'">
                <img
                  alt="..."
                  :src="props.row.avatar"
                  class="shadow-xl rounded-full"
                  width="50"
                  heght="50"
                />
              </span>
            </template>
            <div slot="emptystate" class="text-center">
              No users available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="users.email"
                type="button"
                name="data_user_table.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardUsersTable
  Description: This class representing a cards with teams.
*/

/* Imports */
import ModalUser from "@/components/Modals/Users/ModalUser.vue";
/* /Imports/ */

export default {
  /* 
    Define data with custom teams state values. 
  */
  data() {
    return {
      users: null,
      data_row: null,
      columns: [
        {
          field: "avatar",
          width: '75px',
          sortable: false,
        },
        {
          label: "First Name",
          field: "first_name",
          filterable: true,
        },
        {
          label: "Middle Name",
          field: "middle_name",
          filterable: true,
        },
        {
          label: "Last Name",
          field: "last_name",
          filterable: true,
        },
        {
          label: "Created",
          field: "created_at",
          filterable: true,
        },
        {
          label: "Updated",
          field: "updated_at",
          filterable: true,
        },
      ],
      rows: this.users,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: { 
    ModalUser 
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Show modal for single user. 
    */
    onRowClick(params) {
      this.data_row = params.row;
      this.$modal.show("user");
    },

    /* 
      We got all users and save them to state. 
    */
    getUsers() {
      this.$loading(true);

      this.$store.dispatch("userTable/getAllUsers").then(() => {
        this.users = this.$store.state.userTable.usersData; //Store result from api request in state
        this.$loading(false);
      });
    }
  },

  /* 
    Load all users after the instance. 
  */
  mounted() {
    this.getUsers();
  },
};
</script>
